<template>	
<div>
    <div head :group-id="region.id" class="group-head" @click="onClickGroupItem($event)">
        <div>
            <div class="-wrapper v-center-" style="display: inline-block; padding-bottom: 4px;">
                <input type="checkbox" class="checkbox" v-bind:value="region.id" v-model="isCheckAll" v-bind:id="id + 'checkbox' + region.id" @click="onClickCheckAllGroup()">
                <label v-bind:for="id + 'checkbox' + region.id">
                    <em class="-label">{{region.label}} ({{listSelectedValue.length}}/{{listItem.length}})</em>
                </label>
            </div>
            <button type="button" class="buttons-tbl-header"
                :data-type="sortType"
                @click="callSetSortColumn($event)">
            </button>
            <span v-if="isExpand" class="material-icons expand-icon" @click="onClickExpand()">expand_less</span>
            <span v-else class="material-icons expand-icon" @click="onClickExpand()">expand_more</span>
        </div>
    </div>
    <div v-show="isExpand" list v-bind:class="'list-item-' + region.id">
        <div class="select-item" v-for="(childRegion) of listItem" :key="childRegion.id" :title="childRegion.label">
            <div class="-wrapper v-center- -p-2">
                <input type="checkbox" v-model="listSelectedValue" class="checkbox" v-bind:value="childRegion.id" v-bind:id="id + 'checkbox' + childRegion.id" :key="id + 'checkbox' + childRegion.id" @click="onClickSelectItem(childRegion.id)">
                <label v-bind:for="id + 'checkbox' + childRegion.id">
                    <em class="-label">
                        <span class="ci -font-size-16" v-bind:class="getVenderIcon(region.id)"></span>
                        <span>{{childRegion.label}}</span>
                    </em>
                </label>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
	name: "GroupItem",
	props:{
		region: {
			type: Object,
			default:()=>{}
		},
        id: {
			type: String,
			default: "group-item"
		},
        searchTxt: {
			type: String,
			default: ""
		},
        callSetSelectedValue: {
			type: Function,
			default: ()=>{}
		},
        preSelectedValue: {
			type: Array,
			default: ()=>[]
		}
	},
	data() {
		return {
            listItem: _.cloneDeep(this.region.children),
            listSearchedItem: _.cloneDeep(this.region.children),
            listRootItem: _.cloneDeep(this.region.children),
            isCheckAll: false,
            listSelectedValue: [],
            isExpand: true,
            sortType: "sort" 
		}
    },
    created() {
        this.setPreSelectedValue();
    },
    watch: {
        searchTxt(newVal, oldVal) {
            this.searchText();
        },
        region() {
            this.listItem = _.cloneDeep(this.region.children);
            this.listSearchedItem = _.cloneDeep(this.region.children);
            this.listRootItem = _.cloneDeep(this.region.children);
            
            let selectedValue = [];
            let listItem = this.listItem.map(item => item.id);
            this.listSelectedValue.forEach((item) => {
                let idx = _.indexOf(listItem, item);
                if (idx != -1) {
                    selectedValue.push(item);
                }
            });
            this.listSelectedValue = selectedValue;
            this.setCheckAllGroupItem();
        },
        preSelectedValue() {
            this.setPreSelectedValue();
        }
    },
	methods: {
		onClickGroupItem(event) {
            if (event.target.tagName == 'DIV') {
                this.isExpand = !this.isExpand;
            }
		},
        onClickExpand() {
            this.isExpand = !this.isExpand;
        },
        onClickSelectItem(itemId) {
            if (itemId) {
                let index = this.listSelectedValue.indexOf(itemId);
                if (index > -1) {
                    this.listSelectedValue.splice(index, 1);
                } else {
                    this.listSelectedValue.push(itemId);
                }
                this.setCheckAllGroupItem();
                this.callSetSelectedValue(this.region.id, this.listSelectedValue);
            }
        },
        setCheckAllGroupItem() {
            if (this.listItem.length != 0 && this.listSelectedValue.length >= this.listItem.length) {
                let checkAll = true;
                this.listItem.forEach(item => {
                    if (!_.includes(this.listSelectedValue, item.id)) {
                        checkAll = false;
                        return false;
                    }
                });
                this.isCheckAll = checkAll;
            } else {
                this.isCheckAll = false;
            }
        },
        onClickCheckAllGroup() {
            // clear select all
            if (this.isCheckAll) {
                if (this.searchTxt == "") {
                    this.listSelectedValue = [];
                } else {
                    let selectedValue = _.cloneDeep(this.listSelectedValue);
                    let listItem = this.listItem.map(item => item.id);
                    listItem.forEach((item) => {
                        let idx = _.indexOf(selectedValue, item);
                        if (idx != -1) {
                            selectedValue.splice(idx, 1);
                        }
                    });
                    this.listSelectedValue = selectedValue;
                }
            } else {
                // selected all items
                if (this.searchTxt == "") {
                    this.listSelectedValue = this.listItem.map(item => item.id);
                } else {
                    let selectedValue = _.cloneDeep(this.listSelectedValue);
                    let listItem = this.listItem.map(item => item.id);
                    listItem.forEach((item, index) => {
                        if (!_.includes(selectedValue, item)) {
                            selectedValue.push(item);
                        }
                    });
                    this.listSelectedValue = selectedValue;
                }
            }
            this.callSetSelectedValue(this.region.id, this.listSelectedValue);
        },
        getVenderIcon(venderId) {
            if (venderId === 'azu') {
                venderId = 'azure';
            }
            return "ci-vendor-" + venderId;
        },
        getSortItem(listItem) {
            let listOrdered = [];
            if (this.sortType == 'sort') {
                listOrdered = _.cloneDeep(this.listSearchedItem);
            } else if (this.sortType == 'sort-asce') {
                listOrdered = _.orderBy(listItem, ['label'], ['asc']);
            } else {
                listOrdered = _.orderBy(listItem, ['label'], ['desc']);
            }
            return listOrdered;
        },
        callSetSortColumn(event) {
            if (this.sortType == 'sort') {
                this.sortType = 'sort-asce';
            } else if (this.sortType == 'sort-asce') {
                this.sortType = 'sort-desc';
            } else {
                this.sortType = 'sort';
            }
            this.listItem = this.getSortItem(this.listItem);
            event.stopPropagation();
        },
        searchText() {
            let filterData = _.filter(this.listRootItem, (o) => {
                    return o.id.includes(this.searchTxt) || o.label.toLowerCase().includes(this.searchTxt.toLowerCase());
                });
            this.listSearchedItem = _.cloneDeep(filterData);
            this.listItem = this.getSortItem(filterData);
            this.setCheckAllGroupItem();
        },
        setPreSelectedValue() {
            if (this.preSelectedValue.length > 0) {
                let selectedValue = [];
                let listItem = this.listItem.map(item => item.id);
                this.preSelectedValue.forEach((item) => {
                    let idx = _.indexOf(listItem, item);
                    if (idx != -1) {
                        selectedValue.push(item);
                    }
                });
                this.listSelectedValue = selectedValue;
                this.setCheckAllGroupItem();
            }
        }
	}
}
</script>
<style scoped>
.select-item {
    border-bottom: 1px solid #D3D8E0;
    position: relative;
}
.group-head {
    padding: 4px 8px;
    background-color: #f5f7f9;
    border-bottom: 1px solid #D3D8E0;
    position: relative;
}
.head-title {
    padding: 5px 0px;
}
.title-style, .count-selected {
    display: inline-block;
}
.data-result {
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
}
.expand-icon {
    float: right;
    font-size: 14px;
    padding: 4px 0px;
    cursor: pointer;
}
.select-item em {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 30px);
    display: inline-block;
}
.select-item label {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/GroupSelect/GroupItem.vue